interface IHotelBillingTypes {
  free: string;
  paid: string;
}

export const HotelBillingTypes: IHotelBillingTypes = {
  free: "free",
  paid: "paid",
};
